<div class="h-full w-full flex flex-col overflow-hidden">
    <div class="h-full flex flex-col min-h-0">
        <div class="space-y-8 flex-1 overflow-y-auto min-h-0 scrollbar-transparent">
            <div class="">
                <h2 class="text-base/7 font-semibold text-primary">Compensation</h2>
                @if (createBriefService.pricingUserType() === 'regular') {
                <p class="mt-1 text-sm/6 text-secondary">Below is a breakdown of creator pricing for this brief.</p>
                } @else {
                <p class="mt-1 text-sm/6 text-secondary">How will you compensate the creators for their work?</p>
                }

                @if (createBriefService.pricingUserType() !== 'regular') {
                <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 px-2">
                    <div class="sm:col-span-full">
                        <label for="comment" class="block text-sm/6 font-medium text-primary">
                            Select Compensation Type
                            <p class="text-xs text-secondary">There are many ways to compensate creators, select the one
                                that best suits your needs.</p>
                        </label>

                        <ul role="list" class="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
                            @for (item of remunerationOptions; track $index) {
                            <li class="col-span-1 flex rounded-md border-zinc-500" (click)="selectRemuneration(item)">
                                <div class="flex w-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium cursor-pointer"
                                    [class]="item.class">
                                    @switch (item.type) {
                                    @case (PaymentMethodTypeEnum.CASH) {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6">
                                        <rect width="20" height="12" x="2" y="6" rx="2" />
                                        <circle cx="12" cy="12" r="2" />
                                        <path d="M6 12h.01M18 12h.01" />
                                    </svg>
                                    }
                                    @case (PaymentMethodTypeEnum.PRODUCT) {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6">
                                        <rect x="3" y="8" width="18" height="4" rx="1" />
                                        <path d="M12 8v13" />
                                        <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
                                        <path
                                            d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5" />
                                    </svg>
                                    }
                                    @case (PaymentMethodTypeEnum.VOUCHER) {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6">
                                        <path
                                            d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
                                        <path d="m9 12 2 2 4-4" />
                                    </svg>
                                    }
                                    }
                                </div>

                                <div
                                    class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-zinc-300 dark:border-white/10 cursor-pointer">
                                    <div class="flex-1 truncate px-4 py-2 text-sm">
                                        <a class="font-medium text-primary hover:text-gray-200">{{ item.name
                                            }}</a>
                                        <p class="text-secondary truncate">{{ item.description }}</p>
                                    </div>
                                    <div class="shrink-0 pr-2 flex items-center justify-center text-primary">
                                        @if (createBriefService.remunerationConfig()?.id === item.id) {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-6">
                                            <circle cx="12" cy="12" r="10" />
                                            <path d="m9 12 2 2 4-4" />
                                        </svg>
                                        }
                                    </div>
                                </div>

                            </li>
                            }
                        </ul>
                    </div>
                </div>
                }
            </div>

            <div>
                @if (createBriefService.remunerationConfig() && createBriefService.pricingUserType() !== 'regular') {
                @switch (createBriefService.remunerationConfig()!.id) {
                @case ('pm_cash') {
                <div class="space-y-12 border border-teal-400 bg-teal-500/10 p-4 rounded-lg sm:col-span-full">
                    <div class="">
                        <h2 class="text-sm font-semibold text-primary">Cash Payment Details</h2>
                        <p class="text-xs text-secondary">Creators will be paid cash for their work.</p>
                        @if (createBriefService.remunerationConfig()) {
                        <!-- Shout Plus Specify Payment -->
                        <div class="mt-4 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
                            <div class="col-span-1 sm:col-span-6">
                                <label for="price" class="block text-sm/6 font-medium text-primary">Payment
                                    Amount</label>
                                <div
                                    class="mt-1 relative flex items-center rounded-md bg-white/50 dark:bg-white/5 pl-3 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary">
                                    <div class="shrink-0 text-base text-secondary select-none sm:text-sm/6">
                                        {{ selectedCurrency()?.symbol }}
                                    </div>
                                    <input id="price" type="number" placeholder="0.00"
                                        [(ngModel)]="createBriefService.remunerationConfig()!.value"
                                        [value]="createBriefService.remunerationConfig()!.value"
                                        (input)="updatePaymentMethod()"
                                        class="block min-w-0 grow py-1.5 pr-3 pl-1 text-sm text-primary outline-zinc-300 dark:outline-white/10 placeholder:text-gray-500 focus:outline-none sm:text-sm/6" />
                                    <div class="grid shrink-0 grid-cols-1 focus-within:relative">
                                        <select id="currency" name="currency" aria-label="Currency"
                                            (change)="onCurrencyChange($event)"
                                            class="col-start-1 row-start-1 w-full appearance-none rounded-md py-1.5 pr-7 pl-3 text-base text-secondary placeholder:text-gray-500 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6">
                                            @for (currency of currencies; track $index) {
                                            <option [value]="currency.code">
                                                {{ currency.code }}
                                            </option>
                                            }
                                        </select>
                                        <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                                            class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-400 sm:size-4">
                                            <path
                                                d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                                                clip-rule="evenodd" fill-rule="evenodd" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Shout Plus Specify Payment - END -->
                        }
                    </div>
                </div>
                }
                @case ('pm_product') {
                <div class="space-y-12 border border-rose-400 bg-rose-500/10 p-4 rounded-lg sm:col-span-full">
                    <div class="">
                        <h2 class="text-sm font-semibold text-primary">Product Gifting</h2>
                        <p class="text-xs text-secondary">Creators will be sent the product as compensation for their
                            work.</p>

                        <div class="mt-4 sm:flex flex-row gap-x-4 items-center">
                            <div class="shrink-0">
                                <div
                                    class="h-32 w-full border border-white/15 bg-gray-900 text-white/15 sm:w-32 overflow-hidden">
                                    <atom-ldg-img inputClass="object-cover" w="full" radius="md"
                                        [src]="imageService.getImageSource(createBriefService.selectedProduct()?.productImage, 'gallery_xl')"></atom-ldg-img>
                                </div>
                            </div>
                            <div>
                                <h4 class="text-sm font-bold text-primary">{{
                                    createBriefService.selectedProduct()?.productName }}</h4>
                                <p class="mt-1 text-secondary text-xs">{{
                                    createBriefService.selectedProduct()?.productDescription }}</p>
                            </div>
                        </div>

                    </div>
                </div>
                }
                @case ('pm_voucher') {
                <div class="space-y-12 border border-blue-400 bg-blue-500/10 p-4 rounded-lg sm:col-span-full">
                    <div class="">
                        <h2 class="text-sm font-semibold text-primary">Voucher Details</h2>
                        <p class="text-xs text-secondary">Creators will be given a voucher as payment for their work.
                        </p>

                        <div class="mt-4 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">


                            @if (createBriefService.remunerationConfig()) {
                            <div class="col-span-1 sm:col-span-3">
                                <label for="price" class="block text-sm/6 font-medium text-primary">Voucher
                                    Name</label>
                                <input id="brief-title" placeholder="eg., Summer Sale Discount"
                                    [(ngModel)]="createBriefService.remunerationConfig()!.name"
                                    [value]="createBriefService.remunerationConfig()!.name" type="text"
                                    (input)="updatePaymentMethod()" class="mt-1 input-primary text-primary" />
                            </div>

                            <div class="col-span-1 sm:col-span-3">
                                <label for="price" class="block text-sm/6 font-medium text-primary">Coupon
                                    Code</label>
                                <input id="brief-title" placeholder="eg., SUMMER20"
                                    [(ngModel)]="createBriefService.remunerationConfig()!.code"
                                    [value]="createBriefService.remunerationConfig()!.code" type="text"
                                    (input)="updatePaymentMethod()" class="mt-1 input-primary text-primary" />
                            </div>

                            <div class="col-span-1 sm:col-span-3">
                                <label for="price" class="block text-sm/6 font-medium text-primary">Discount
                                    Type</label>
                                <div class="mt-1 hidden sm:block">
                                    <nav aria-label="Tabs" class="flex space-x-4">
                                        <a (click)="selectVoucherType(VoucherTypeEnum.PERCENTAGE)"
                                            class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                                            [class]="getVoucherTypeClass(VoucherTypeEnum.PERCENTAGE)">Percentage (%)</a>
                                        <a (click)="selectVoucherType(VoucherTypeEnum.FIXED_AMOUNT)"
                                            class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                                            [class]="getVoucherTypeClass(VoucherTypeEnum.FIXED_AMOUNT)">Fixed Amount ({{
                                            selectedCurrency()?.symbol }})</a>
                                    </nav>
                                </div>
                            </div>

                            <div class="col-span-1 sm:col-span-3">
                                <label for="price" class="block text-sm/6 font-medium text-primary">Discount
                                    Value</label>
                                @if (selectedVoucherType() && selectedVoucherType() === VoucherTypeEnum.PERCENTAGE)
                                {
                                <div class="">
                                    <div
                                        class="mt-1 flex items-center rounded-md bg-white/5 px-3 outline-1 -outline-offset-1 outline-white/10 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-primary">
                                        <input id="price" type="text" name="price" placeholder="10"
                                            aria-describedby="price-currency"
                                            [(ngModel)]="createBriefService.remunerationConfig()!.value"
                                            [value]="createBriefService.remunerationConfig()!.value"
                                            (input)="updatePaymentMethod()"
                                            [max]="createBriefService.remunerationConfig()!.voucher_type && createBriefService.remunerationConfig()!.voucher_type === VoucherTypeEnum.PERCENTAGE ? 100 : null"
                                            class="block min-w-0 grow bg-transparent py-1.5 pr-3 pl-1 text-base text-white placeholder:text-gray-500 focus:outline-none sm:text-sm/6" />
                                        <div id="price-currency"
                                            class="shrink-0 text-base text-gray-400 select-none sm:text-sm/6">%
                                        </div>
                                    </div>
                                </div>
                                } @else {
                                <div
                                    class="mt-1 relative flex items-center rounded-md bg-white/50 dark:bg-white/5 pl-3 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary">
                                    <div class="shrink-0 text-base text-secondary select-none sm:text-sm/6">
                                        {{ selectedCurrency()?.symbol }}
                                    </div>
                                    <input id="price" type="number" placeholder="0.00"
                                        [(ngModel)]="createBriefService.remunerationConfig()!.value"
                                        [value]="createBriefService.remunerationConfig()!.value"
                                        (input)="updatePaymentMethod()"
                                        class="block min-w-0 grow py-1.5 pr-3 pl-1 text-sm text-primary outline-zinc-300 dark:outline-white/10 placeholder:text-gray-500 focus:outline-none sm:text-sm/6" />
                                    <div class="grid shrink-0 grid-cols-1 focus-within:relative">
                                        <select id="currency" name="currency" aria-label="Currency"
                                            (change)="onCurrencyChange($event)"
                                            class="col-start-1 row-start-1 w-full appearance-none rounded-md py-1.5 pr-7 pl-3 text-base text-secondary placeholder:text-gray-500 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6">
                                            @for (currency of currencies; track $index) {
                                            <option [value]="currency.code">
                                                {{ currency.code }}
                                            </option>
                                            }
                                        </select>
                                        <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                                            class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-400 sm:size-4">
                                            <path
                                                d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                                                clip-rule="evenodd" fill-rule="evenodd" />
                                        </svg>
                                    </div>
                                </div>
                                }
                            </div>
                            }
                        </div>
                    </div>
                </div>
                }
                @default {
                <h2 class="text-sm font-semibold text-primary">Use Rgular User Pricing Model</h2>
                }
                }
                } @else {
                @switch (createBriefService.remunerationConfig()!.id) {
                @case ('pm_cash') {
                <div class="space-y-12 border p-4 rounded-lg sm:col-span-full"
                    [class]="createBriefService.selectedUgcOnly() ? 'border-teal-400 bg-teal-500/10' : 'border-primary bg-primary/10'">
                    <div class="">
                        <h2 class="text-sm font-semibold text-primary">Cash Payment Details</h2>
                        <p class="text-xs text-secondary">Creators will be paid cash for their work.</p>
                        @if (createBriefService.remunerationConfig()) {
                        <!-- Shout Plus Specify Payment -->
                        <div class="mt-4 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
                            <!-- Base Price -->
                            <div class="col-span-1 sm:col-span-3">
                                <label for="price" class="block text-sm/6 font-medium text-primary">
                                    Base Price per video
                                    <p class="text-xs text-secondary">The base price is the price of the brief before
                                        any modifiers/audiences are applied.</p>
                                </label>
                                <div disabled
                                    class="mt-1 relative flex items-center rounded-md bg-white/50 dark:bg-white/5 pl-3 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary">
                                    <div class="shrink-0 text-base text-secondary select-none sm:text-sm/6">
                                        {{ selectedCurrency()?.symbol }}
                                    </div>
                                    <div
                                        class="block min-w-0 grow py-1.5 pr-3 pl-1 text-sm text-primary outline-zinc-300 dark:outline-white/10 placeholder:text-gray-500 focus:outline-none sm:text-sm/6">
                                        <p class="text-primary">{{ getBasePrice() | number:'1.2-2' }}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- Base Price - END-->

                            <!-- Video Count -->
                            <div class="col-span-1 sm:col-span-3">
                                <label for="price" class="block text-sm/6 font-medium text-primary">
                                    Number of Videos
                                    <p class="text-xs text-secondary">The price is multiplied by the number of videos.
                                    </p>
                                </label>
                                <div disabled
                                    class="mt-1 relative flex items-center rounded-md bg-white/50 dark:bg-white/5 pl-3 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary">

                                    <div
                                        class="block min-w-0 grow py-1.5 pr-3 pl-1 text-sm text-primary outline-zinc-300 dark:outline-white/10 placeholder:text-gray-500 focus:outline-none sm:text-sm/6">
                                        <p class="text-primary">{{ createBriefService.videosPerCreator() }}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- Video Count - END-->

                            @if (createBriefService.selectedPrimaryChannel()) {
                            <!-- Audience Prices -->
                            <div class="col-span-1 sm:col-span-full">
                                <label for="price" class="block text-sm/6 font-medium text-primary">
                                    Expect to pay
                                    <p class="text-xs text-secondary">For creators with audiences within the following
                                        groups you can expect to pay...
                                    </p>
                                </label>
                                <ul role="list"
                                    class="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4">
                                    @for (level of createBriefService.selectedPricingModel()?.influencerLevels; track
                                    $index) {
                                    <li class="col-span-1 flex flex-row justify-between items-center rounded-md border border-zinc-500">
                                        <div
                                            class="flex flex-1 items-center justify-between">
                                            <div class="flex-1 truncate px-4 py-2 text-sm">
                                                <a class="font-medium text-primary hover:text-gray-200">{{ level.title
                                                    }}</a>
                                                <p class="text-secondary truncate">{{
                                                    formatService.convertIntToString(level.followersFrom)}} to {{
                                                    formatService.convertIntToString(level.followersTo) }}</p>
                                            </div>
                                        </div>

                                        <div
                                            class="flex shrink-0 items-center justify-center px-4">
                                            <h2 class="text-primary">{{ selectedCurrency()?.symbol }} {{ getAudiencePriceExpecttaion(level.bonusValue) | number:'1.2-2' }}</h2>
                                        </div>

                                    </li>
                                    }
                                </ul>
                            </div>
                            <!-- Audience Prices - END -->
                            } @else {
                            <!-- Expect to pay -->
                            <div class="col-span-1 sm:col-span-full">
                                <label for="price" class="block text-sm/6 font-medium text-primary">
                                    Expect to pay
                                    <p class="text-xs text-secondary">Each creator will be paid at least this amount.
                                    </p>
                                </label>
                                <div disabled
                                    class="mt-1 relative flex items-center rounded-md bg-white/50 dark:bg-white/5 pl-3 outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary">
                                    <div class="shrink-0 text-base text-secondary select-none sm:text-sm/6">
                                        {{ selectedCurrency()?.symbol }}
                                    </div>
                                    <div
                                        class="block min-w-0 grow py-1.5 pr-3 pl-1 text-sm text-primary outline-zinc-300 dark:outline-white/10 placeholder:text-gray-500 focus:outline-none sm:text-sm/6">
                                        <p class="text-primary">{{ getBasePrice() *
                                            createBriefService.videosPerCreator() | number:'1.2-2' }}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- Expect to pay - END-->
                            }


                        </div>
                        <!-- Shout Plus Specify Payment - END -->
                        }
                    </div>
                </div>
                }
                }
                }

            </div>
        </div>

    </div>
</div>